import React from 'react';

import { graphql } from 'gatsby';

import { WheelsBanner } from './wheels-banner';
import { WheelsRoutes } from './wheels-routes';

// ********************************************************************************
export const wheelsPriceMapping = (props: any, locale: string) => {
  return {};
};
type Props = {};
export const WheelsPrice = (props: Props) => {
  return (
    <>
      <WheelsBanner />
      <WheelsRoutes />
    </>
  );
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment WheelsPrice on StrapiWidgetrels {
    wheelsPrice {
      key: id
      widgetPosition
    }
  }
`;